const ATTRIBUTION_KEY  = 'indiads_funnel_attr';
const POPUP_SHOWN_KEY  = 'discover_popup_shown';
const WELCOME_NUDGE_KEY = 'fb_funnel_welcome';
const FB_ROUTE_ENTRY_KEY = 'fb_route_entry';

// Call on /discover page load to capture UTM params before they're lost on redirect.
export function storeFunnelAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const source   = params.get('utm_source')   || '';
    const campaign = params.get('utm_campaign') || '';
    const medium   = params.get('utm_medium')   || '';
    if (source || campaign || medium) {
      sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify({ source, campaign, medium, ts: Date.now() }));
    }
  } catch {}
}

export function getFunnelAttribution() {
  try {
    const raw = sessionStorage.getItem(ATTRIBUTION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

// Whether the current session originated from the FB paid funnel (/discover entry).
export function isFbFunnelSession() {
  try {
    const attr = getFunnelAttribution();
    if (attr?.source) {
      const s = attr.source.toLowerCase();
      if (s.includes('facebook') || s.includes('fb') || s.includes('instagram')) return true;
    }
    // Also treat any /discover landing as the FB funnel even without UTM tags
    // (e.g. link shortened via bit.ly that strips params).
    return sessionStorage.getItem('discover_entry') === '1';
  } catch { return false; }
}

export function markDiscoverEntry() {
  try { sessionStorage.setItem('discover_entry', '1'); } catch {}
}

// /fb is the Facebook-ads landing variant with no Google button (Google's
// account picker doesn't work well in Meta's in-app browser). Signup needs
// to know this too, so it can hide its own Google button to match.
export function markFbRouteEntry() {
  try { sessionStorage.setItem(FB_ROUTE_ENTRY_KEY, '1'); } catch {}
}

export function isFbRouteEntry() {
  try { return sessionStorage.getItem(FB_ROUTE_ENTRY_KEY) === '1'; } catch { return false; }
}

// Popup gate: show at most once per browser session.
export function hasShownSignupPopup() {
  try { return sessionStorage.getItem(POPUP_SHOWN_KEY) === '1'; } catch { return false; }
}

export function markSignupPopupShown() {
  try { sessionStorage.setItem(POPUP_SHOWN_KEY, '1'); } catch {}
}

// After Funnel B signup, Library reads and clears this flag to show upgrade nudge once.
export function markWelcomeNudge() {
  try { sessionStorage.setItem(WELCOME_NUDGE_KEY, '1'); } catch {}
}

export function consumeWelcomeNudge() {
  try {
    const val = sessionStorage.getItem(WELCOME_NUDGE_KEY);
    if (val === '1') { sessionStorage.removeItem(WELCOME_NUDGE_KEY); return true; }
    return false;
  } catch { return false; }
}
